import CollectionDetailTab, {
  CollectionDetailTabItem,
  defaultCollectionDetailTabItem
} from '@/components/templates/collection-detail/CollectionDetailTab.vue'

import CollectionDetailTabBasic, {
  CollectionDetailTabBasicItem,
  defaultCollectionDetailTabBasicItem
} from '@/components/templates/collection-detail/CollectionDetailTabBasic.vue'

import CollectionDetailTabLocation, {
  CollectionDetailTabLocationItem,
  defaultCollectionDetailTabLocationItem
} from '@/components/templates/collection-detail/CollectionDetailTabLocation.vue'

import CollectionDetailTabBudget, {
  CollectionDetailTabBudgetItem,
  defaultCollectionDetailTabBudgetItem
} from '@/components/templates/collection-detail/CollectionDetailTabBudget.vue'

import CollectionDetailTabOther, {
  CollectionDetailTabOtherItem,
  defaultCollectionDetailTabOtherItem
} from '@/components/templates/collection-detail/CollectionDetailTabOther.vue'

import CollectionDetailTabLending, {
  CollectionDetailTabLendItem,
  defaultCollectionDetailTabLendItem
} from '@/components/templates/collection-detail/CollectionDetailTabLending.vue'

export {
  CollectionDetailTab,
  CollectionDetailTabItem,
  defaultCollectionDetailTabItem,
  CollectionDetailTabBasic,
  CollectionDetailTabBasicItem,
  defaultCollectionDetailTabBasicItem,
  CollectionDetailTabLocation,
  CollectionDetailTabLocationItem,
  defaultCollectionDetailTabLocationItem,
  CollectionDetailTabBudget,
  CollectionDetailTabBudgetItem,
  defaultCollectionDetailTabBudgetItem,
  CollectionDetailTabOther,
  CollectionDetailTabOtherItem,
  defaultCollectionDetailTabOtherItem,
  CollectionDetailTabLending,
  CollectionDetailTabLendItem,
  defaultCollectionDetailTabLendItem
}
